import { useIntl } from '@leagueplatform/locales';
import { Footer } from '@leagueplatform/solutions-foundation';
import logoWithText from 'assets/HealthCoLogo.svg';
import { Disclaimer } from './disclaimer-section.component';
import { useAppFooterLinks } from './use-app-footer-links.hook';

export const AppFooter = () => {
  const { footerLinks, appDownloadLinks } = useAppFooterLinks();
  const { formatMessage } = useIntl();

  return (
    <Footer
      footerLinks={footerLinks}
      footerBody={<Disclaimer />}
      appDownloadIconLinks={appDownloadLinks}
      brandingSection={
        <img
          src={logoWithText}
          alt={formatMessage({ id: 'STR_APP_NAME' })}
          width="160px"
        />
      }
    />
  );
};
